import { Component, OnInit } from '@angular/core';
import { Base64 } from 'js-base64';
import { Router, ActivatedRoute } from '@angular/router';
import { NavbarService} from 'src/app/Components/navbar/navbar.service';
import { LocalStorageService } from 'src/app/Services/auth-service/local-storage.service';
import { ENDPOINTS, ORG_DETAILS } from 'src/app/app.config';
import { AppService } from 'src/app/app.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AlertsService } from '../../../Components/alerts/alerts.service';

import { CheckoutLocalStorageService as CheckoutLocalStorageServiceNew } from '../../Checkout-new/checkout-local-storage.service';
import { CheckoutApiService } from '../../Checkout-new/checkout-api.service';
import { LoaderService } from '../../../Components/loader/loader.service';
import {config} from 'src/configs/config';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html'
})
export class OrderConfirmationComponent implements OnInit {
  orderId:any = "";
  orderNumer:any = "";
  orderSummary:any = "";
  shippingAddress:any = "";
  userInfoForm: UntypedFormGroup;
  validateForm: boolean = false;
  // validatepasswordLoginForm: boolean = false;
  showPasswordField: Boolean = true;
  showNameField: Boolean = true;
  showEmailField: Boolean = true;
  CONFIG = config;
  showPswd: Boolean = false;
  customerData: any;
  product: any;
  showalertmsg: boolean = true;

  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };

  paymentMethod:any = "";

  awaitingStatus = {
    status:"",
    id:0
  }

  confirmStatus = {
    sttaus:"",
    id:0
  }

  activateOrder:any = "";
  customerDetails:any;
  deliveryType;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private localService: LocalStorageService,
    private route: ActivatedRoute,
    private navbarService: NavbarService,
    private appService: AppService,
    private alertService: AlertsService,
    private router: Router,
    private checkoutLocalStorageService1: CheckoutLocalStorageServiceNew,
    private checkoutApiService: CheckoutApiService,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    window.scrollTo(0,0);
    this.customerDetails = JSON.parse(this.localService.get('CustomerData'))
    this.loaderService.emitLoading();
    this.navbarService.updateAdminFormEvent('clearSearchTerm');
    this.userInfoForm = new UntypedFormGroup({
      name: this.formBuilder.control('', [Validators.minLength(3), Validators.maxLength(40), Validators.pattern("^[a-zA-Z][a-z A-Z]*$")]),
      email: this.formBuilder.control('', [Validators.maxLength(50), Validators.email, Validators.pattern("^[a-z0-9+_.-]+@[a-z0-9]+[.][a-z+]+$")]),
      new_password: this.formBuilder.control('', [Validators.minLength(6), Validators.maxLength(20)]),
      confirm_password: this.formBuilder.control('', [])
    }, { validators: OrderConfirmationComponent.checkPswd })

    if(this.route.snapshot.queryParamMap){
      this.appService.removeSession();
      this.appService.createSession();
      this.checkoutLocalStorageService1.clearOrderConfirmation();
      this.orderId = Number(this.route.snapshot.queryParamMap.get('id'))
      this.getAllOrderDetails();
     // this.validateOrder(this.orderId);
    }
    this.loaderService.emitComplete();
    // this.customerData = this.customerService.getCustomerData();
    // this.getUserDetails()
  }
  get f() { return this.userInfoForm.controls; }
  static checkPswd(group: AbstractControl): { [key: string]: boolean } {
    let pass = group.get('new_password').value;
    let confirmPass = group.get('confirm_password').value;
    return pass === confirmPass ? null : { passwdNotMatch: true }
  }

  validpasswd(): void {
    if (this.userInfoForm.hasError('passwdNotMatch')) {
      this.userInfoForm.controls['confirm_password'].setErrors({ 'incorrect': true })
    }
  }
  showPassword() {
    this.showPswd = !this.showPswd;
  }
  getUserDetails(){
    let reqData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "phone_number": this.customerData.Mobile.toString()
        }
      }
    }
    // API CALL TO FIND EXISTING/NEW USER
    this.appService.postApiCall(reqData, ENDPOINTS.GETALL_USERS).subscribe(
      resp => {
        if(resp.result.data[0].email){
          this.showEmailField = false;
        }
        else{
          this.showEmailField = true;
        }
        if(resp.result.data[0].password){
          this.showPasswordField = false;
        }
        else{
          this.showPasswordField = true;
        }
        if(resp.result.data[0].first_name){
          this.showNameField = false;
        }
        else{
          this.showNameField = true;
        }
      },
      err => {
        if (err.error.error.message) {
          console.log(err.error.error.message)
        }
        else {
          console.log('Something bad happened; Please try again!')
        }
      })
  }
  createAccount(){
    if(this.showPassword && this.userInfoForm.value.new_password!='' && this.userInfoForm.value.confirm_password==''){
      this.alertService.error('please confirm the password!',this.options)
      return
    }
    if(this.userInfoForm.valid){
      this.validateForm=false;
      let userVariables={};
      if(this.showEmailField){
        userVariables['email'] = this.userInfoForm.value.email
      }
      if(this.showNameField){
        userVariables['first_name'] = this.userInfoForm.value.name
      }
      if(this.showPasswordField){
        userVariables['password'] = this.userInfoForm.value.new_password
      }
      if(!this.userInfoForm.value.new_password && !this.userInfoForm.value.email && !this.userInfoForm.value.name){
        this.alertService.error('please fill the form', this.options)
        return
      }
      let requestBody = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "payload":{
          "update_customer": userVariables
        },
        "extras": {
          "find": {
            "id": this.customerData.userId
          }
        }
      }
      this.appService.postApiCall(requestBody, ENDPOINTS.UPDATE_CUSTOMER).subscribe(
        resp => {
          this.showalertmsg = true;
          this.alertService.success(resp.message, this.options)
          if(this.userInfoForm.value.name){
          this.localService.set('UserName', this.userInfoForm.value.name);
          this.appService.userName=this.userInfoForm.value.name;
          }
          if (resp.success === 1 && resp.status_code === 200) {
            setTimeout(() => {
              this.router.navigate(['/']);              
            }, 1000);
          }
        },
        err => {
          if (err.error.message) {
            console.log(err.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        });
  }
    else{
      this.validateForm=true;
    }

  }
  getAllOrderDetails() {
    document.getElementById("bestgiftsloader").style.display = "block";
    let requestBody = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "id": this.orderId
        }
      }
    }
    this.appService.postApiCall(requestBody, ENDPOINTS.GETORDERDETAILS).subscribe(
      resp => {
        var orderData = resp.result.data[0];
        if(orderData.shipping.shipping_addresses.length > 0){
          this.shippingAddress = orderData.shipping.shipping_addresses[0];
          console.log(this.shippingAddress,'this.shippingAddress',orderData)
        }
        
        this.paymentMethod = orderData.payment.payment_method;
        if(this.paymentMethod === "ICICI Payment Gateway"){
          this.paymentMethod = "Online Payment"
        }
        this.orderNumer = orderData.order_number
        this.orderSummary = orderData.order_review.order_summary;
        this.deliveryType = orderData.delivery.delivery_type;

          let requestData = {
            "domain_name": ORG_DETAILS.DOMAIN_NAME,
            "user_id": ORG_DETAILS.USER_ID,
            "extras": {
              "find": {
                "customer_id": Number(orderData.customer_id),
                "event_id":Number(orderData.event_id),
              },
              "pagination": false,
              "paginationDetails": {
                "limit": 0,
                "pageSize": 2
              },
              "sorting": true,
              "sortingDetails": {
                "sortfield": "sort_order",
                "sortorder": 1
              }
            }
          }
          this.appService.postApiCall(requestData, ENDPOINTS.FORM_GETBYID).subscribe(
            resp => {
              if (resp.success == 1) {
                if (resp.result.data.length > 0) {
                  window.scrollTo(0, 0)
                  this.product = resp.result.data[0];
                  let formData = {}

                  formData = {
                    "customer_id": Number(this.product.customer_id),
                    "customer_name": this.product.customer_name,
                    "company_name": this.product.company_name,
                    "phone": this.product.phone,
                    "email_id": this.product.email_id,
                    "status": "Pending",
                    "status_approval_date": "timestamp",
                    "registartion_start_date": "timestamp",
                    "claim_eligible_status": this.product.claim_eligible_status,
                    "event_id": Number(this.product.event_id),
                    "event_name": this.product.event_name,
                    "event_start_date": this.product.event_start_date,
                    "event_end_date": this.product.event_end_date,
                    "assigned_to": null,
                    "applied_for_MAI": this.product.applied_for_MAI,
                    "send_email": false,
                    "eligibility_remarks": "invalid",
                    "forms": [
                      {
                        "name": "MAI SCHEME",
                        "status": this.product.forms[0].status,
                        "values": [
                          {
                            "field_type": "TextField",
                            "key": "name_of_the_company",
                            "value": this.product.forms[0].values[0].value,
                            "modified": this.product.forms[0].values[0].modified,
                            "remarks": this.product.forms[0].values[0].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "pan_card_number",
                            "value": this.product.forms[0].values[1].value,
                            "modified": this.product.forms[0].values[1].modified,
                            "remarks": this.product.forms[0].values[1].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "cin_number",
                            "value": this.product.forms[0].values[2].value,
                            "modified": this.product.forms[0].values[2].modified,
                            "remarks": this.product.forms[0].values[2].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "iec_number",
                            "value": this.product.forms[0].values[3].value,
                            "modified": this.product.forms[0].values[3].modified,
                            "remarks": this.product.forms[0].values[3].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "name_of_the_owner",
                            // "value": this.sendapplication_cle.value.name_of_the_owner,
                            "value": this.product.forms[0].values[4].value,
                            "modified": this.product.forms[0].values[4].modified,
                            "remarks": this.product.forms[0].values[4].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "whether_belongs_to_MSME",
                            "value": this.product.forms[0].values[5].value,
                            "modified": this.product.forms[0].values[5].modified,
                            "remarks": this.product.forms[0].values[5].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "employed_women",
                            "value": this.product.forms[0].values[6].value,
                            "modified": this.product.forms[0].values[6].modified,
                            "remarks": this.product.forms[0].values[6].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "category",
                            "value": this.product.forms[0].values[7].value,
                            "modified": this.product.forms[0].values[7].modified,
                            "remarks": this.product.forms[0].values[7].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "exporters_from",
                            "value": this.product.forms[0].values[8].value,
                            "modified": this.product.forms[0].values[8].modified,
                            "remarks": this.product.forms[0].values[8].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "address",
                            "value": this.product.forms[0].values[9].value,
                            "modified": this.product.forms[0].values[9].modified,
                            "remarks": this.product.forms[0].values[9].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "mobile_no",
                            "value": this.product.forms[0].values[10].value,
                            "modified": this.product.forms[0].values[10].modified,
                            "remarks": this.product.forms[0].values[10].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "telephone_no",
                            "value": this.product.forms[0].values[11].value,
                            "modified": this.product.forms[0].values[11].modified,
                            "remarks": this.product.forms[0].values[11].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "fax_no",
                            "value": this.product.forms[0].values[12].value,
                            "modified": this.product.forms[0].values[12].modified,
                            "remarks": this.product.forms[0].values[12].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "email",
                            "value": this.product.forms[0].values[13].value,
                            "modified": this.product.forms[0].values[13].modified,
                            "remarks": this.product.forms[0].values[13].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "website",
                            "value": this.product.forms[0].values[14].value,
                            "modified": this.product.forms[0].values[14].modified,
                            "remarks": this.product.forms[0].values[14].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "space_requirement",
                            // "value": this.product.forms[0].values[15].value,
                            "value": orderData.square_meter,
                            "modified": this.product.forms[0].values[15].modified,
                            "remarks": this.product.forms[0].values[15].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "type_of_company",
                            "value": this.product.forms[0].values[16].value,
                            "modified": this.product.forms[0].values[16].modified,
                            "remarks": this.product.forms[0].values[16].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "membership_no_with_the_council",
                            "value": this.product.forms[0].values[17].value,
                            "modified": this.product.forms[0].values[17].modified,
                            "remarks": this.product.forms[0].values[17].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "hs_code_of_the_products_displaying_in_the_fair",
                            "value": this.product.forms[0].values[18].value,
                            "modified": this.product.forms[0].values[18].modified,
                            "remarks": this.product.forms[0].values[18].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "annual_production_capacity",
                            "value": this.product.forms[0].values[19].value,
                            "modified": this.product.forms[0].values[19].modified,
                            "remarks": this.product.forms[0].values[19].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "main_markets",
                            "value": this.product.forms[0].values[20].value,
                            "modified": this.product.forms[0].values[20].modified,
                            "remarks": this.product.forms[0].values[20].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "products_to_be_displayed",
                            "value": [{
                              "field_type": "TextField",
                              "key": "contact_executive",
                              "value": this.product.forms[0].values[21].value[0].value,
                              "modified": this.product.forms[0].values[22].modified,
                              "remarks": this.product.forms[0].values[22].remarks,
                              "validation": ""
                            }, {
                              "field_type": "TextField",
                              "key": "contact_details",
                              "value": this.product.forms[0].values[21].value[1].value,
                              "modified": this.product.forms[0].values[22].modified,
                              "remarks": this.product.forms[0].values[22].remarks,
                              "validation": ""
                            }, {
                              "field_type": "TextField",
                              "key": "mobile_no",
                              "value": this.product.forms[0].values[21].value[2].value,
                              "modified": this.product.forms[0].values[22].modified,
                              "remarks": this.product.forms[0].values[22].remarks,
                              "validation": ""
                            }, {
                              "field_type": "TextField",
                              "key": "email",
                              "value": this.product.forms[0].values[21].value[3].value,
                              "modified": this.product.forms[0].values[22].modified,
                              "remarks": this.product.forms[0].values[22].remarks,
                              "validation": ""
                            }, {
                              "field_type": "TextField",
                              "key": "website",
                              "value": this.product.forms[0].values[21].value[4].value,
                              "modified": this.product.forms[0].values[22].modified,
                              "remarks": this.product.forms[0].values[22].remarks,
                              "validation": ""
                            }, {
                              "field_type": "TextField",
                              "key": "annual_production",
                              "value": this.product.forms[0].values[21].value[5].value,
                              "modified": this.product.forms[0].values[22].modified,
                              "remarks": this.product.forms[0].values[22].remarks,
                              "validation": ""
                            }, {
                              "field_type": "TextField",
                              "key": "main_markets",
                              "value": this.product.forms[0].values[21].value[6].value,
                              "modified": this.product.forms[0].values[22].modified,
                              "remarks": this.product.forms[0].values[22].remarks,
                              "validation": ""
                            }, {
                              "field_type": "TextField",
                              "key": "products_to_be_displayed",
                              "value": this.product.forms[0].values[21].value[7].value,
                              "modified": this.product.forms[0].values[22].modified,
                              "remarks": this.product.forms[0].values[22].remarks,
                              "validation": ""
                            },
                            {
                              "field_type": "TextField",
                              "key": "product_images",
                              "value": this.product.forms[0].values[21].value[8].value,
                              "modified": this.product.forms[0].values[22].modified,
                              "remarks": this.product.forms[0].values[22].remarks,
                              "validation": ""
                            },
                            {
                              "field_type": "TextField",
                              "key": "brief_history",
                              "value": this.product.forms[0].values[21].value[9].value,
                              "modified": this.product.forms[0].values[22].modified,
                              "remarks": this.product.forms[0].values[22].remarks,
                              "validation": ""
                            }],
                            "modified": this.product.forms[0].values[21].modified,
                            "remarks": this.product.forms[0].values[21].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "brief_history",
                            "value": this.product.forms[0].values[22].value,
                            "modified": this.product.forms[0].values[22].modified,
                            "remarks": this.product.forms[0].values[22].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "passport_details",
                            "value": this.product.forms[0].values[23].value,
                            "modified": this.product.forms[0].values[23].modified,
                            "remarks": this.product.forms[0].values[23].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "confirm_name",
                            "value": this.product.forms[0].values[24].value,
                            "modified": this.product.forms[0].values[24].modified,
                            "remarks": this.product.forms[0].values[24].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "signature",
                            "value": this.product.forms[0].values[25].value,
                            "modified": this.product.forms[0].values[25].modified,
                            "remarks": this.product.forms[0].values[25].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "confirm_designation",
                            "value": this.product.forms[0].values[26].value,
                            "modified": this.product.forms[0].values[26].modified,
                            "remarks": this.product.forms[0].values[26].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "confirm_date",
                            "value": this.product.forms[0].values[27].value,
                            "modified": this.product.forms[0].values[27].modified,
                            "remarks": this.product.forms[0].values[27].remarks,
                            "validation": ""
                          }, {
                            "field_type": "TextField",
                            "key": "seal",
                            "value": this.product.forms[0].values[28].value,
                            "modified": this.product.forms[0].values[28].modified,
                            "remarks": this.product.forms[0].values[28].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "name_of_the_owner1",
                            "value": "",
                            "modified": this.product.forms[0].values[29].modified,
                            "remarks": this.product.forms[0].values[29].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "country_code",
                            "value": this.product.forms[0].values[30].value,
                            "modified": "",
                            "remarks": this.product.forms[0].values[22].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "builtup_space",
                            "value": orderData.selected_space,
                            "modified": "",
                            "remarks": this.product.forms[0].values[15].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "corner_space",
                            "value": orderData.corner_space,
                            "modified": "",
                            "remarks": this.product.forms[0].values[15].remarks,
                            "validation": ""
                          },
                        ]
                      },
                      {
                        "name": "MAI AIRFARE REIMBURSEMENT",
                        "status": this.product.forms[1].status,
                        "values": [
                          {
                            "field_type": "TextField",
                            "key": "ref_no",
                            "value": this.product.forms[1].values[0].value,
                            "modified": this.product.forms[1].values[0].modified,
                            "remarks": this.product.forms[1].values[0].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date",
                            "value": this.product.forms[1].values[1].value,
                            "modified": this.product.forms[1].values[1].modified,
                            "remarks": this.product.forms[1].values[1].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "cle_membership_no",
                            "value": this.product.forms[1].values[2].value,
                            "modified": this.product.forms[1].values[2].modified,
                            "remarks": this.product.forms[1].values[2].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date_of_membership",
                            "value": this.product.forms[1].values[3].value,
                            "modified": this.product.forms[1].values[3].modified,
                            "remarks": this.product.forms[1].values[3].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "firm_details",
                            "value": this.product.forms[1].values[4].value,
                            "modified": this.product.forms[1].values[4].modified,
                            "remarks": this.product.forms[1].values[4].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "iec_number",
                            "value": this.product.forms[1].values[5].value,
                            "modified": this.product.forms[1].values[5].modified,
                            "remarks": this.product.forms[1].values[5].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "eh_th_certificate_no_date",
                            "value": this.product.forms[1].values[6].value,
                            "modified": this.product.forms[1].values[6].modified,
                            "remarks": this.product.forms[1].values[6].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "valid_upto",
                            "value": this.product.forms[1].values[7].value,
                            "modified": this.product.forms[1].values[7].modified,
                            "remarks": this.product.forms[1].values[7].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "fob_value_of_export_during_last_financial_year",
                            "value": this.product.forms[1].values[8].value,
                            "modified": this.product.forms[1].values[8].modified,
                            "remarks": this.product.forms[1].values[8].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "name_of_event",
                            "value": this.product.forms[1].values[9].value,
                            "modified": this.product.forms[1].values[9].modified,
                            "remarks": this.product.forms[1].values[9].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "place",
                            "value": this.product.forms[1].values[10].value,
                            "modified": this.product.forms[1].values[10].modified,
                            "remarks": this.product.forms[1].values[10].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "country",
                            "value": this.product.forms[1].values[11].value,
                            "modified": this.product.forms[1].values[11].modified,
                            "remarks": this.product.forms[1].values[11].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "from",
                            "value": this.product.forms[1].values[12].value,
                            "modified": this.product.forms[1].values[12].modified,
                            "remarks": this.product.forms[1].values[12].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "to",
                            "value": this.product.forms[1].values[13].value,
                            "modified": this.product.forms[1].values[13].modified,
                            "remarks": this.product.forms[1].values[13].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date_of_departure_from_india",
                            "value": this.product.forms[1].values[14].value,
                            "modified": this.product.forms[1].values[14].modified,
                            "remarks": this.product.forms[1].values[14].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date_of_arrival_in_india",
                            "value": this.product.forms[1].values[15].value,
                            "modified": this.product.forms[1].values[15].modified,
                            "remarks": this.product.forms[1].values[15].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "details_of_proposal_already_submitted_in_the_same_financial_year",
                            "value": this.product.forms[1].values[16].value,
                            "modified": this.product.forms[1].values[16].modified,
                            "remarks": this.product.forms[1].values[16].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "details_of_earlier_participations_in_the_same_event",
                            "value": this.product.forms[1].values[17].value,
                            "modified": this.product.forms[1].values[17].modified,
                            "remarks": this.product.forms[1].values[17].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "name_of_the_person_going_abroad",
                            "value": this.product.forms[1].values[18].value,
                            "modified": this.product.forms[1].values[18].modified,
                            "remarks": this.product.forms[1].values[18].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "designation_of_the_person_going_abroad",
                            "value": this.product.forms[1].values[19].value,
                            "modified": this.product.forms[1].values[19].modified,
                            "remarks": this.product.forms[1].values[19].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "place1",
                            "value": this.product.forms[1].values[20].value,
                            "modified": this.product.forms[1].values[20].modified,
                            "remarks": this.product.forms[1].values[20].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date1",
                            "value": this.product.forms[1].values[21].value,
                            "modified": this.product.forms[1].values[21].modified,
                            "remarks": this.product.forms[1].values[21].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "signature",
                            "value": this.product.forms[1].values[22].value,
                            "modified": this.product.forms[1].values[22].modified,
                            "remarks": this.product.forms[1].values[22].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "domestic_turnover",
                            "value": this.product.forms[1].values[23].value,
                            "modified": this.product.forms[1].values[23].modified,
                            "remarks": this.product.forms[1].values[23].remarks,
                            "validation": ""
                          },
            
                        ]
                      },
                      {
                        "name": "MAI APPROVAL",
                        "status": this.product.forms[2].status,
                        "submitted_on": this.product.forms[2].submitted_on,
                        "deficiency_noticedBy_cle": this.product.forms[2].deficiency_noticedBy_cle,
                        "deficiency_receivedBy_cle": this.product.forms[2].deficiency_receivedBy_cle,
                        "values": [
                          {
                            "field_type": "TextField",
                            "key": "claim_form",
                            "value": this.product.forms[2].values[0].value,
                            "modified": this.product.forms[2].values[0].modified,
                            "remarks": this.product.forms[2].values[0].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "boarding_pass",
                            "value": this.product.forms[2].values[1].value,
                            "modified": this.product.forms[2].values[1].modified,
                            "remarks": this.product.forms[2].values[1].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "reg_certificate",
                            "value": this.product.forms[2].values[2].value,
                            "modified": this.product.forms[2].values[2].modified,
                            "remarks": this.product.forms[2].values[2].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "passport_copy",
                            "value": this.product.forms[2].values[3].value,
                            "modified": this.product.forms[2].values[3].modified,
                            "remarks": this.product.forms[2].values[3].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "arrival_departure",
                            "value": this.product.forms[2].values[4].value,
                            "modified": this.product.forms[2].values[4].modified,
                            "remarks": this.product.forms[2].values[4].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "air_ticket",
                            "value": this.product.forms[2].values[5].value,
                            "modified": this.product.forms[2].values[5].modified,
                            "remarks": this.product.forms[2].values[5].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "fob_certificate",
                            "value": this.product.forms[2].values[6].value,
                            "modified": this.product.forms[2].values[6].modified,
                            "remarks": this.product.forms[2].values[6].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "chatered_account",
                            "value": this.product.forms[2].values[7].value,
                            "modified": this.product.forms[2].values[7].modified,
                            "remarks": this.product.forms[2].values[7].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "annual_report",
                            "value": this.product.forms[2].values[8].value,
                            "modified": this.product.forms[2].values[8].modified,
                            "remarks": this.product.forms[2].values[8].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "annual_turnover",
                            "value": this.product.forms[2].values[9].value,
                            "modified": this.product.forms[2].values[9].modified,
                            "remarks": this.product.forms[2].values[9].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "receipts",
                            "value": this.product.forms[2].values[10].value,
                            "modified": this.product.forms[2].values[10].modified,
                            "remarks": this.product.forms[2].values[10].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "past_activities",
                            "value": this.product.forms[2].values[11].value,
                            "modified": this.product.forms[2].values[11].modified,
                            "remarks": this.product.forms[2].values[11].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "activity_undertaken",
                            "value": this.product.forms[2].values[12].value,
                            "modified": this.product.forms[2].values[12].modified,
                            "remarks": this.product.forms[2].values[12].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "accountant_certificate",
                            "value": this.product.forms[2].values[13].value,
                            "modified": this.product.forms[2].values[13].modified,
                            "remarks": this.product.forms[2].values[13].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "membership_certificate",
                            "value": this.product.forms[2].values[14].value,
                            "modified": this.product.forms[2].values[14].modified,
                            "remarks": this.product.forms[2].values[14].remarks,
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "monthly_export_return",
                            "value": this.product.forms[2].values[15].value,
                            "modified": this.product.forms[2].values[15].modified,
                            "remarks": this.product.forms[2].values[15].remarks,
                            "validation": ""
                          }
            
                        ]
                      },
                      {
                        "name": "MAI AIRFARE FINAL REIMBURSEMENT",
                        "status": this.product.forms[1].status,
                        "values": [
                          {
                            "field_type": "TextField",
                            "key": "ref_no",
                            "value": this.product.forms[3].values[0].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date",
                            "value": this.product.forms[3].values[1].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "cle_membership_no",
                            "value": this.product.forms[3].values[2].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date_of_membership",
                            "value": this.product.forms[3].values[3].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "firm_details",
                            "value": this.product.forms[3].values[4].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "iec_number",
                            "value": this.product.forms[3].values[5].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "eh_th_certificate_no_date",
                            "value": this.product.forms[3].values[6].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "ssi_certificate",
                            "value": this.product.forms[3].values[7].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "fob_value_of_export_during_last_financial_year",
                            "value": this.product.forms[3].values[8].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "name_of_event",
                            "value": this.product.forms[3].values[9].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "place",
                            "value": this.product.forms[3].values[10].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "country",
                            "value": this.product.forms[3].values[11].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "from",
                            "value": this.product.forms[3].values[12].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "to",
                            "value": this.product.forms[3].values[13].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date_of_departure_from_india",
                            "value": this.product.forms[3].values[14].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date_of_arrival_in_india",
                            "value": this.product.forms[3].values[15].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "details_of_proposal_already_submitted_in_the_same_financial_year",
                            // "value": this.sendapplication_cle.value.details_of_proposal_already_submitted_in_the_same_financial_year,
                            "value": this.product.forms[3].values[16].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "details_of_earlier_participations_in_the_same_event",
                            // "value": this.sendapplication_cle.value.details_of_earlier_participations_in_the_same_event,
                            "value": this.product.forms[3].values[17].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "assistance_availed",
                            "value": this.product.forms[3].values[18].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "name_of_the_person_going_abroad",
                            "value": this.product.forms[3].values[19].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "designation_of_the_person_going_abroad",
                            "value": this.product.forms[3].values[20].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "return_airfare",
                            "value": this.product.forms[3].values[21].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "expenditure_incurred",
                            "value": this.product.forms[3].values[22].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "amount_claimed",
                            "value": this.product.forms[3].values[23].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "place1",
                            "value": this.product.forms[3].values[24].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "name",
                            "value": this.product.forms[3].values[25].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "designation",
                            "value": this.product.forms[3].values[26].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "applicant_firm",
                            "value": this.product.forms[3].values[27].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date1",
                            "value": this.product.forms[3].values[28].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "signature",
                            "value": this.product.forms[3].values[29].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "departure_image",
                            "value": this.product.forms[3].values[30].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "arrival_image",
                            "value": this.product.forms[3].values[31].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "seal",
                            "value": this.product.forms[3].values[32].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "AirTicket",
                            "value": this.product.forms[3].values[33].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "Receipt",
                            "value": this.product.forms[3].values[34].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "Bank Advice",
                            "value": this.product.forms[3].values[35].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "government_bodies_data",
                            "value": this.product.forms[3].values[36].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "ssi_image",
                            "value": this.product.forms[3].values[37].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "valid_upto",
                            "value": this.product.forms[3].values[38].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
            
                        ]
                      },
                      {
                        "name": "FEEDBACK",
                        "status": "",
                        "values": [
                          {
                            "field_type": "TextField",
                            "key": "name_of_firm",
                            "value": this.product.forms[4].values[0].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "name",
                            "value": this.product.forms[4].values[1].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "designation",
                            "value": this.product.forms[4].values[2].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "new_products",
                            "value": this.product.forms[4].values[3].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "market_assessment",
                            "value": this.product.forms[4].values[4].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "contacts",
                            "value": this.product.forms[4].values[5].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "others",
                            "value": this.product.forms[4].values[6].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "products_displayed",
                            "value": this.product.forms[4].values[7].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "no_of_meetings",
                            "value": this.product.forms[4].values[8].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "no_of_visitors",
                            "value": this.product.forms[4].values[9].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "orders_booked_quantity",
                            "value": this.product.forms[4].values[10].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "orders_booked_value",
                            "value": this.product.forms[4].values[11].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "business_expected_quantity",
                            "value": this.product.forms[4].values[12].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "business_expected_value",
                            "value": this.product.forms[4].values[13].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "kind_of_business",
                            "value": this.product.forms[4].values[14].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "export_potential",
                            "value": this.product.forms[4].values[15].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "export_of_leather",
                            "value": this.product.forms[4].values[16].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "joint_venture",
                            "value": this.product.forms[4].values[17].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "views_on_arrangement",
                            "value": this.product.forms[4].values[18].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "pavillion_location",
                            "value": this.product.forms[4].values[19].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "stand_construction",
                            "value": this.product.forms[4].values[20].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "coordination",
                            "value": this.product.forms[4].values[21].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "export_potential_country",
                            // "value": this.sendapplication_cle.value.details_of_proposal_already_submitted_in_the_same_financial_year,
                            "value": this.product.forms[4].values[22].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "appropriate_event",
                            // "value": this.sendapplication_cle.value.details_of_earlier_participations_in_the_same_event,
                            "value": this.product.forms[4].values[23].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "appropriate_event_reason",
                            "value": this.product.forms[4].values[24].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "organize_participation",
                            "value": this.product.forms[4].values[25].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "organize_participation_reason",
                            "value": this.product.forms[4].values[26].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "participate_fair",
                            "value": this.product.forms[4].values[27].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "participate_fair_reason",
                            "value": this.product.forms[4].values[28].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "suggestions",
                            "value": this.product.forms[4].values[29].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "suggestions_reason",
                            "value": this.product.forms[4].values[30].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "overall_suggestions",
                            "value": this.product.forms[4].values[31].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "name1",
                            "value": this.product.forms[4].values[32].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "designation1",
                            "value": this.product.forms[4].values[33].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "date",
                            "value": this.product.forms[4].values[34].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "signature",
                            "value": this.product.forms[4].values[35].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          }
                        ]
                      },
                      {
                        "name": "DELEGATION AND BSM",
                        "status": this.product.forms[5].status,
                        "values": [
                          {
                            "field_type": "TextField",
                            "key": "name_of_company",
                            "value": this.product.forms[5].values[0].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "name",
                            "value": this.product.forms[5].values[1].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "designation",
                            "value": this.product.forms[5].values[2].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "mobile_number",
                            "value": this.product.forms[5].values[3].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "address",
                            "value": this.product.forms[5].values[4].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "phone_number",
                            "value": this.product.forms[5].values[5].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "email_id",
                            "value": this.product.forms[5].values[6].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "website",
                            "value": this.product.forms[5].values[7].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "products_manufactured",
                            "value": this.product.forms[5].values[8].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "no_of_persons",
                            "value": this.product.forms[5].values[9].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "annual_production_capacity",
                            "value": this.product.forms[5].values[10].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "business_details",
                            "value": this.product.forms[5].values[11].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                          {
                            "field_type": "TextField",
                            "key": "brief_history",
                            "value": this.product.forms[5].values[12].value,
                            "modified": "",
                            "remarks": "",
                            "validation": ""
                          },
                        ]
                      },
                    ]
                  }
            
                  let obj = {
                    domain_name: ORG_DETAILS.DOMAIN_NAME,
                    user_id: ORG_DETAILS.USER_ID,
                    payload: {
                      update_form: formData
                    },
                    extras: {
                      find: {
                        id: Number(this.product.id)
                      }
                    }
                  }
            
                  this.appService.postApiCall(obj, ENDPOINTS.FORM_UPDATE).subscribe(resp => {
                    if (resp) {
                      if (resp.success == 1) {
                        document.getElementById("bestgiftsloader").style.display = "none";
            
                      }
            
                      else {
                        window.scrollTo(0, 0)
                        this.alertService.warn("Something bad happened", this.options);
                        document.getElementById("bestgiftsloader").style.display = "none";
                      }
                    }
                  },
       
                  )
                } 
                  else {
                    document.getElementById("bestgiftsloader").style.display = "none";
                  }
                } else {
                  document.getElementById("bestgiftsloader").style.display = "none";
                }
      
            })
        

        // if(resp.result.data[0].system_label.toUpperCase() === 'AWAITING PAYMENT'){
        //   this.updateOnlinePaymentOrder();
        // }
      },
      err => {
        if (err.error.message) {
          console.log(err.error.message)
        }
        else {
          console.log('Something bad happened; Please try again!')
        }
      });
  }

  updateOnlinePaymentOrder(){
    this.getOrderStatus().then(
      respData => {
        let res:any = respData;
        if(res){
          let requestData = 
              {
                  domain_name: ORG_DETAILS.DOMAIN_NAME,
                  user_id: ORG_DETAILS.USER_ID,
                  payload: {
                      order: {
                          status: this.confirmStatus.sttaus,
                          system_label: "Confirmed",
                          status_id: this.confirmStatus.id
                      },
                      new_value: {
                          status: this.confirmStatus.sttaus,
                          system_label: "Confirmed"
                      },
                      old_value: {
                          status: this.awaitingStatus.status,
                          system_label: "Awaiting Payment"
                      }
                  },
                  extras: {
                      find: {
                          id: this.orderId
                      }
                  }
          }
          this.appService.postApiCall(requestData, ENDPOINTS.ORDER_UPDATION).subscribe(
            resp => {
              console.log("this.orderId",this.orderId)
              if(resp.success === 1){

              }
            },
            err => {
            
            })
        }
      })    
  }

  getOrderStatus(){
    return new Promise((resolve, reject) => {
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.GET_ORDERSTATUS).then(
        respData => {
          let res:any = respData;
          if(res.success){
            let orderapiData:any = res.data;
            orderapiData.forEach(element => {
              if(element.system_label.toUpperCase() === 'AWAITING PAYMENT'){
                this.awaitingStatus.status = element.custom_label;
                this.awaitingStatus.id = element.id;
              }
              if(element.system_label.toUpperCase() === 'CONFIRMED'){
                this.confirmStatus.sttaus = element.custom_label;
                this.confirmStatus.id = element.id;
              }
              resolve(true);
            });
          }
        }
      )
    })
  }

  validateOrder(orderId){
    let requestData = {
      domain_name:ORG_DETAILS.DOMAIN_NAME,
      orderid:orderId,
      confirmationpage:1,
      failurepage:0,
      customer_id:this.customerDetails.userid
    }
    this.appService.postApiCall(requestData, ENDPOINTS.ORDER_ACTIVATION).subscribe(
      resp => {
        if(resp.success === 1){
          this.activateOrder = "success";
          this.getAllOrderDetails();
          this.loaderService.emitComplete();
        }
        else{
          this.activateOrder = "failure";
          this.loaderService.emitComplete();
        }
      },
      err => {
        this.activateOrder = "failure";
        this.loaderService.emitComplete();
      })
  }

}
